module.exports = __webpack_public_path__ + "static/media/mj.a8e9a876.png";